import { deferLoad } from './get-v2';
deferLoad();
